export const selectLanguages = (reduxState) => reduxState.translation.languages;

export const selectProfiles = (reduxState) => reduxState.translation.profiles;
